/* Une photo de votre pièce → les affiches qui vont avec.
 *
 * Tout se passe DANS LE NAVIGATEUR. La photo est celle du salon de quelqu'un : elle n'a
 * aucune raison de partir sur un serveur, et ne pas la transmettre est plus simple à tenir
 * qu'une promesse de ne pas la garder. Effet de bord utile : pas de CORS, pas de dépendance
 * à la disponibilité de l'app, et la réponse est instantanée.
 *
 * Le calcul est le portage exact de catalogue/palette.py et de la fonction noter() de
 * catalogue/palette-reco.js. Les SEUILS ne sont pas recopiés ici : ils arrivent dans
 * palette-index.json, émis par palette.py — une valeur recopiée finit toujours par diverger.
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-palette]");
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var I18N = {};
  try { I18N = JSON.parse(($("[data-palette-i18n]") || {}).textContent || "{}"); } catch (e) { I18N = {}; }
  /* Le filtre `t` de Shopify rend les traductions déjà échappées : « Clarté » passe, mais
     une apostrophe ressortirait en « &#39; ». Même décodage que le composeur. */
  var ENT = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'", "&#x27;": "'" };
  var t = function (k, fb) {
    var v = I18N[k];
    if (v == null || v === "") return fb;
    v = String(v);
    return v.indexOf("&") < 0 ? v : v.replace(/&(?:amp|lt|gt|quot|#39|#x27);/g, function (m) { return ENT[m]; });
  };

  var IDX = null;              // l'index catalogue, chargé une fois
  var K = null;                // tables de clés (couleurs, clartés…)
  var C = null;                // constantes de lecture d'image, venues de palette.py
  var piece = null;            // dernière lecture de photo
  var pieceVisee = "";

  /* ---------- Lecture de l'image ---------- */

  function famille(r, g, b) {
    /* rgb -> hsv, puis mêmes plages et mêmes seuils que couleurs.py, avec le facteur
       assoupli propre aux pièces : un mur vert sauge est vert, alors que sur une affiche la
       même saturation serait du papier. */
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var v = mx, s = mx === 0 ? 0 : d / mx, h = 0;
    if (d !== 0) {
      if (mx === r) h = ((g - b) / d) % 6;
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60; if (h < 0) h += 360;
    }
    if (v < C.v_sombre) return "black";
    var nom = "red";
    for (var i = 0; i < C.plages.length; i++) {
      if (h >= C.plages[i][1] && h < C.plages[i][2]) { nom = C.plages[i][0]; break; }
    }
    /* ⛔ UN GRIS FROID N'EST PAS UNE COULEUR. `facteur_piece` (0,5) est là pour qu'un mur
       vert sauge reste vert, mais il descend le seuil du bleu à 0,11 : dans une pièce
       éclairée au jaune avec du jour par la fenêtre, TOUTES les ombres tirent sur le bleu
       et franchissent ça. Plafond, portes blanches, canapé gris, murs à l'ombre partaient
       ainsi en « Bleu », ce qu'aucun plancher de surface ne pouvait rattraper puisque la
       teinte couvrait un quart de l'image. On garde l'assouplissement, sous un plancher
       absolu : en dessous, le pixel redevient un neutre (Adrien, 03/08/2026). */
    /* ⛔ MAIS CE PLANCHER NE VAUT PAS POUR LE VERT, ET IL A ANNULÉ LA RAISON D'ÊTRE DE
       `facteur_piece`. Le seuil voulu pour un mur vert est `seuils.green` (0,20) × 0,5 = 0,10,
       écrit exprès pour qu'un vert sauge reste vert ; le plancher de 0,20, posé juste après
       contre les ombres bleues, l'écrasait par ce `Math.max`. Mesuré le 05/08/2026 sur la
       photo d'Adrien : un mur sauge est à 0,105 de saturation, teinte 107 degrés, donc VERT
       sans ambiguïté, et l'outil annonçait « Gris » et « Blanc ».
       ⚠️ L'exemption s'arrête au vert, et c'est le point. Le plancher existe contre les
       teintes que la LUMIÈRE fabrique : les ombres tirent sur le bleu, un éclairage chaud
       pousse vers l'orange et le rouge. Aucune lampe d'intérieur ne fabrique du vert : un mur
       vert a été peint en vert. */
    var plancher = nom === "green" ? 0 : (C.s_min_piece != null ? C.s_min_piece : 0.20);
    var smin = Math.max(plancher, (C.seuils[nom] || 0.3) * C.facteur_piece);
    if (s < smin) {
      if (v < 0.22) return "black";
      if (v >= 0.82 && s < 0.12) return "white";
      if ((r - b) >= C.ecart_chaud) return v >= 0.62 ? "beige" : "brown";
      return "gray";
    }
    if (nom === "orange") return v >= 0.62 ? "orange" : "brown";
    if (nom === "yellow") return v >= 0.45 ? "yellow" : "brown";
    return nom;
  }

  function lirePiece(img) {
    var cv = document.createElement("canvas");
    var e = 240 / Math.max(img.naturalWidth, img.naturalHeight);
    cv.width = Math.max(1, Math.round(img.naturalWidth * Math.min(1, e)));
    cv.height = Math.max(1, Math.round(img.naturalHeight * Math.min(1, e)));
    var cx = cv.getContext("2d", { willReadFrequently: true });
    cx.drawImage(img, 0, 0, cv.width, cv.height);
    var px = cx.getImageData(0, 0, cv.width, cv.height).data;
    var poids = {}, brut = {}, lum = 0, n = px.length / 4;
    for (var i = 0; i < px.length; i += 4) {
      var r = px[i] / 255, g = px[i + 1] / 255, b = px[i + 2] / 255;
      var f = famille(r, g, b);
      lum += Math.max(r, g, b);
      var fr = C.fr[f] || f;
      /* Une couleur franche pèse plus qu'un neutre : c'est elle qui donne le ton, même si
         le mur blanc occupe dix fois plus de surface. */
      poids[fr] = (poids[fr] || 0) + (C.neutres.indexOf(fr) >= 0 ? C.poids_neutre : 1);
      brut[fr] = (brut[fr] || 0) + 1;      // la surface VRAIE, sans pondération
    }
    var total = 0, ordre = [];
    Object.keys(poids).forEach(function (k) { total += poids[k]; ordre.push([k, poids[k]]); });
    ordre.sort(function (a, b2) { return b2[1] - a[1]; });
    /* ⛔ UNE DOMINANTE OCCUPE DE LA PLACE. La pondération ci-dessus classe les couleurs,
       elle ne doit pas décider seule qui EXISTE : en décotant les neutres à 0,15 elle
       effondre le total, et 1,5 % de pixels francs franchissent alors les 8 % du seuil.
       Un salon beige et bois s'est ainsi vu annoncer « Bleu » à cause d'un seul tableau
       accroché au mur (Adrien, 03/08/2026) : une toile de la taille d'une affiche, c'est
       a dire EXACTEMENT ce que le client vient remplacer. Le classement reste pondéré,
       mais on ne nomme une couleur que si elle tient une vraie part de l'image. */
    var aireMin = C.aire_min != null ? C.aire_min : 0.06;
    var dom = ordre.filter(function (x) {
      return x[1] / (total || 1) >= C.part_min && (brut[x[0]] || 0) / (n || 1) >= aireMin;
    }).slice(0, 3).map(function (x) { return x[0]; });
    /* Le repli prend la plus GRANDE surface, pas la tête du classement pondéré : sinon
       une photo sans dominante nette retomberait sur l'accent qu'on vient d'écarter. */
    if (!dom.length) {
      var large = null;
      Object.keys(brut).forEach(function (k) { if (!large || brut[k] > brut[large]) large = k; });
      if (large) dom = [large];
    }
    var cv2 = lum / n;
    return {
      palette: dom,
      clarte: cv2 < C.clarte[0] ? "Sombre" : (cv2 < C.clarte[1] ? "Moyen" : "Clair"),
      valeur: cv2
    };
  }

  /* ---------- Score : portage de noter() ---------- */

  var CONTRASTE = {
    "Sombre|Clair": [2.2, "eclaire_mur_sombre"],
    "Sombre|Moyen": [0.8, null],
    "Sombre|Sombre": [-1.0, "se_fond"],
    "Moyen|Clair": [1.4, "ressort_valeur_moyenne"],
    "Moyen|Sombre": [1.2, "ancrage_sombre"],
    "Moyen|Moyen": [-0.6, "se_fond"],
    "Clair|Sombre": [1.8, "poids_piece_claire"],
    "Clair|Moyen": [1.0, null],
    "Clair|Clair": [-0.9, "se_fond"]
  };

  /* C.teintes est indexé par les noms INTERNES (red, orange…) alors que les palettes
     manipulent les noms français. Sans cette conversion, chaque comparaison de teinte
     rendait null et le score de couleur était entièrement inerte : le classement ne
     reposait plus que sur la clarté et la pièce. palette.py fait la même conversion
     (son dictionnaire EN), elle avait juste été oubliée au portage.
     « navy » est écarté : il partage « Bleu » avec « blue », qui porte la teinte. */
  var EN = null;
  function versInterne(fr) {
    if (!EN) {
      EN = {};
      Object.keys(C.fr).forEach(function (k) { if (k !== "navy") EN[C.fr[k]] = k; });
    }
    return EN[fr];
  }
  function ecart(a, b) {
    var x = C.teintes[versInterne(a)], y = C.teintes[versInterne(b)];
    if (x == null || y == null) return null;
    return Math.abs(((x - y + 180) % 360) - 180);
  }

  function noter(p, coul, clarte, densite, pieces) {
    var pts = 0, raisons = [], fam = "accorde";
    coul.slice(0, 3).forEach(function (ac, rang) {
      var w = 1 - 0.25 * rang;
      p.palette.forEach(function (pc) {
        var e = ecart(pc, ac);
        if (e === null) return;
        if (e <= 90) {
          var accord = 2 * Math.max(0, 1 - Math.abs(e - 45) / 55);
          pts += accord * w;
          if (accord > 1.2 && !raisons.length) {
            raisons.push(t("accorde", "s’accorde à vos tons __C__").replace("__C__", pc.toLowerCase()));
          }
        } else if (Math.abs(e - 180) <= 45) {
          pts += 1.1 * w;
          if (!raisons.length) {
            raisons.push(t("contraste", "contraste franc avec vos tons __C__").replace("__C__", pc.toLowerCase()));
            fam = "contraste";
          }
        }
      });
    });
    var c = CONTRASTE[p.clarte + "|" + clarte];
    /* La raison de CLARTÉ passe en second. Elle est vraie mais elle se répète d'une carte
       à l'autre — « ressort sur un mur de valeur moyenne » sur les vingt-quatre résultats
       n'apprend rien. C'est la raison de COULEUR qui distingue une affiche d'une autre. */
    /* Une raison de couleur, une de clarté : les deux axes du raisonnement, plutôt que
       deux fois le même. « s'accorde à vos tons marron · s'accorde à vos tons orange » dit
       une seule chose ; « s'accorde à vos tons marron · éclaire un mur sombre » en dit deux. */
    if (c) { pts += c[0]; if (c[1]) raisons.push(t(c[1], "")); }
    var neutrePartage = p.palette.some(function (x) {
      return C.neutres.indexOf(x) >= 0 && coul.indexOf(x) >= 0;
    });
    if (neutrePartage) pts += 0.3;
    var toutNeutre = coul.length && coul.every(function (x) { return C.neutres.indexOf(x) >= 0; })
      && p.palette.every(function (x) { return C.neutres.indexOf(x) >= 0; });
    if (toutNeutre) pts -= 0.7;
    if (pieceVisee) {
      if (pieces.indexOf(pieceVisee) >= 0) pts += 2.5;
      else pts -= 3;
    }
    pts += { "Épuré": 0.35, "Équilibré": 0.15, "Chargé": 0 }[densite] || 0;
    /* ⚠️ UNE SEULE RAISON, pas deux. Enchaînées par un point médian, elles prenaient trois
       lignes sous chaque affiche — plus que le titre — et se lisaient comme une notice
       technique : « contraste franc avec vos tons marron · donne du poids à une pièce
       claire ». Le client n'a pas besoin de l'argumentaire complet sous une vignette ; il a
       besoin de savoir POURQUOI celle-ci lui est montrée. La première raison est la plus
       forte, c'est celle qui a pesé le plus dans le score. */
    /* On GARDE toutes les raisons (jusqu'à trois) : la carte n'en montre qu'une pour ne pas
       peser plus que le titre, la fenêtre « voir sur mon mur » les montre toutes sous
       « Pourquoi cette affiche ? ». Le raisonnement complet existe, il est simplement rangé
       là où on a le temps de le lire. */
    return { score: pts, fam: fam, raisons: raisons.filter(Boolean).slice(0, 3) };
  }

  /* ---------- Rendu ---------- */

  /* Le classement dit ce qui va avec la pièce ; le seul réglage laissé au client est la
     pièce elle-même. Les facettes couleur et densité ont été retirées le 28/07/2026 : elles
     redonnaient à la main les axes qu'on venait de calculer pour lui. */
  var TOUT = null;             // tous les classés, avant filtrage
  var MONTRE = 24;
  var montre = MONTRE;

  function classer() {
    if (!piece || !IDX) return;
    var res = [];
    for (var i = 0; i < IDX.length; i++) {
      var a = IDX[i];
      var coul = a[3].map(function (x) { return K.couleurs[x]; });
      var cla = K.clartes[a[4]], den = K.densites[a[5]];
      var r = noter(piece, coul, cla, den, a[6].map(function (x) { return K.pieces[x]; }));
      /* Ventes et vues voyagent à part du score : le tri les compare l'une après l'autre,
         avant la couleur. Un index antérieur n'a pas ces colonnes — elles valent 0 et le
         classement retombe sur le score seul. */
      /* ⚠️ Colonnes 7 et 8, pas 8 et 9. La ligne compte 9 champs (0 à 8) : le prédécesseur
         `pop` occupait la 7, remplacée par deux colonnes. J'avais décalé d'un cran, donc
         le tri lisait les vues comme des ventes et un champ inexistant comme des vues —
         autrement dit il ne triait rien. Un index lu par position ne pardonne pas. */
      var ventes = a[7] || 0, vues = a[8] || 0;
      res.push({ h: a[0], titre: a[1], img: a[2], score: r.score, fam: r.fam, raisons: r.raisons,
                 coul: coul, clarte: cla, densite: den, pieces: a[6].map(function (x) { return K.pieces[x]; }),
                 ventes: ventes, vues: vues });
    }
    /* Ordre demandé : ce qui s'est vendu d'abord, ce qui a été le plus regardé ensuite,
       le reste après. Comparaison lexicographique et non score composite — sinon un
       nombre de vues finirait par compenser une absence de vente. Tant que le catalogue
       compte peu de ventes, c'est l'accord avec la pièce qui décide, ce qui est le
       comportement voulu : la page reste une recommandation, pas un palmarès. */
    res.sort(function (x, y) {
      if (y.ventes !== x.ventes) return y.ventes - x.ventes;
      if (y.vues !== x.vues) return y.vues - x.vues;
      return y.score - x.score;
    });
    TOUT = res;
    montre = MONTRE;
    rendre();
  }

  function rendre() {
    if (!TOUT) return;
    var l = TOUT.slice();
    afficher(l.slice(0, montre), l.length);
  }

  /* ⚠️ PAS DE FILTRES SUR CETTE PAGE, retirés le 28/07/2026.
     Le raisonnement de la page EST le filtre : on lit le mur, on en déduit une teinte
     voisine et un contraste de clarté, on classe. Redonner à la main les axes qu'on vient
     de calculer, c'était proposer au client de défaire le travail — cocher « bleu » sur un
     mur marron annule la règle de teinte voisine qu'on lui explique deux lignes plus haut.
     Le tri qui reste est celui qu'il maîtrise vraiment : la pièce. */

  /* Une phrase commence par une majuscule. Les raisons sont composées à partir de fragments
     (« s'accorde à vos tons marron »), ce qui les faisait toutes commencer en minuscule sous
     les affiches — elles se lisaient comme des étiquettes techniques, pas comme une parole. */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>\"]/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch];
    });
  }

  function capitale(s) {
    s = String(s || "");
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  }

  /* La feuille mobile. `is-open` sur la barre suffit à la faire monter : l'animation est
     dans base.css. L'état est gardé à part parce que la barre est reconstruite à chaque
     filtrage — sans ça, cocher une valeur refermerait la feuille sous le doigt. */
  var feuilleOuverte = false;
  function basculerFeuille(ouvrir) {
    feuilleOuverte = !!ouvrir;
    var bar = document.querySelector("[data-pal-bar]");
    if (!bar) return;
    bar.classList.toggle("is-open", feuilleOuverte);
    var b = bar.querySelector("[data-pal-open]");
    if (b) b.setAttribute("aria-expanded", feuilleOuverte ? "true" : "false");
    var v = bar.querySelector(".filters__backdrop");
    if (v) v.hidden = !feuilleOuverte;
    document.body.classList.toggle("filters-sheet-open", feuilleOuverte);
  }

  function afficher(l, total) {
    var g = $("[data-palette-resultats]");
    var pal = $("[data-palette-lecture]");
    if (pal) {
      pal.hidden = false;
      pal.innerHTML = '<span class="pal-lecture__t">' + t("votre_piece", "Votre pièce") + "</span>" +
        '<span class="pal-lecture__vals">' +
        /* ⛔ ON TRADUIT L'AFFICHAGE, PAS LA DONNEE. `piece.palette` et `piece.clarte`
           portent les noms francais de l'index, et c'est sur eux que tout le classement
           compare : les traduire ici casserait le score. La pastille anglaise disait
           « Marron » parce qu'elle montrait la cle telle quelle (Adrien, 03/08/2026).
           Les cles n'ont pas d'accent, un simple minuscule suffit a les rejoindre. */
        piece.palette.map(function (c) {
          return '<span class="pal-chip" style="--pc:' + (TEINTE[c] || "#bbb") + '">'
            + esc(t("coul_" + c.toLowerCase(), c)) + "</span>";
        }).join("") +
        '<span class="pal-chip pal-chip--val">'
        + esc(t("clarte_" + piece.clarte.toLowerCase(), piece.clarte)) + "</span></span>";
    }
    /* ⚠️ LE PARTI PRIS DE LA PAGE. La section des résultats prend la teinte dominante du
       mur : c'est le seul endroit du site où on la connaît, et c'est toute la promesse —
       voir les affiches sur SON mur plutôt que sur notre crème. Très diluée côté CSS
       (16 %) : elle doit se sentir, pas se voir, sinon elle concurrence les affiches. */
    peindrePourquoi();
    var reco = $("[data-palette-reco]");
    if (reco) {
      reco.hidden = false;
      reco.style.setProperty("--mur", TEINTE[piece.palette[0]] || "#efe9dd");
    }
    /* ⚠️ LA CARTE DES PAGES COLLECTION, mêmes classes. La page avait sa propre carte —
       titre en Arial gras, raison juste dessous dans la même police : les deux se lisaient
       comme deux titres. Sur une carte de collection, le titre est en serif et tout ce qui
       l'accompagne en sans : c'est le contraste de POLICE qui sépare, pas la couleur.
       On reprend donc `.prod-card` et sa hiérarchie, et la raison prend la place — et le
       traitement — de la ligne d'auteur. */
    /* Trois familles plutôt qu'une liste plate. Ce ne sont pas des étiquettes inventées :
       ce sont les trois chemins que le score emprunte déjà — la teinte voisine, le contraste
       de couleur, et les affiches chargées qui demandent de l'aplomb. Un client qui hésite
       choisit d'abord une intention, pas une affiche. */
    /* ⚠️ La famille est posée au CALCUL (`r.fam`), pas devinée en comparant des chaînes
       traduites : un texte allemand ou grec n'aurait jamais correspondu. */
    function famille(x) {
      if (x.densite === "Chargé") return "audace";
      return x.fam === "contraste" ? "contraste" : "accorde";
    }
    var ordre = ["accorde", "contraste", "audace"];
    var titres = { accorde: t("fam_accorde", "Elles s’accordent à votre mur"),
                   contraste: t("fam_contraste", "Elles créent un contraste"),
                   audace: t("fam_audace", "Les plus audacieuses") };
    var parFamille = { accorde: [], contraste: [], audace: [] };
    l.forEach(function (x) { parFamille[famille(x)].push(x); });

    g.innerHTML = ordre.filter(function (f) { return parFamille[f].length; }).map(function (f) {
      return '<h3 class="pal__fam">' + esc(titres[f]) + "</h3>" +
        '<div class="pal__fam-grid">' + carte(parFamille[f]) + "</div>";
    }).join("");
    g.hidden = false;
    majPlus(l, total);
    return;

    function carte(liste) { return liste.map(function (x) {
      var url = x.img ? (x.img.indexOf("http") === 0 ? x.img : IDXPREFIXE + x.img) : "";
      return '<a class="prod-card pal-card" href="' + ROOT + "products/" + x.h + '" data-handle="' + x.h + '">' +
        '<span class="inner"><span class="thumb" style="background-image:url(\'' + url + '\')" role="img" aria-label="' + esc(x.titre) + '"></span></span>' +
        '<span class="prod-card__meta">' +
          '<span class="prod-card__t">' + x.titre + "</span>" +
          /* ⚠️ CINQUIÈME essai. La couleur, puis la taille, puis la police n'ont pas suffi :
             un texte seul sous un titre se lit comme une suite du titre, quoi qu'on lui
             fasse. Il lui faut une ÉTIQUETTE — « Pourquoi ? » — qui le désigne comme autre
             chose qu'un titre. Une différence de style ne remplace pas une différence de
             nature. */
          (x.raisons.length ? '<span class="pal-card__r sans"><em>' +
            esc(t("pourquoi_court", "Pourquoi ?")) + "</em>" + capitale(x.raisons[0]) + "</span>" : "") +
          '<button type="button" class="pal-card__mur sans" data-palette-voir="' + esc(x.h) + '">' +
            esc(t("voir_mur", "Voir sur mon mur")) + "</button>" +
        "</span></a>";
    }).join(""); }
  }

  function majPlus(l, total) {
    var plus = $("[data-palette-plus]");
    if (plus) {
      var reste = (total || l.length) - l.length;
      plus.hidden = reste <= 0;
      plus.textContent = t("voir_plus", "Voir plus");
      observerFin(plus);
    }
    var vide = $("[data-palette-vide]");
    if (vide) vide.hidden = true;
  }

  /* « Voir sur mon mur ».
     ⚠️ On ne devine PAS où est le mur. Une pose automatique tomberait un jour sur le canapé,
     et un aperçu faux coûte plus cher que pas d'aperçu. L'affiche arrive en haut au centre —
     là où un mur est le plus souvent libre — et c'est le client qui la déplace : il sait où
     il veut l'accrocher, nous non. La taille est indicative et le dit. */
  var mur = $("[data-palette-mur]");
  var murArt = $("[data-palette-mur-art]");
  var murScene = $("[data-palette-mur-scene]");
  var murPos = { x: 0.5, y: 0.28, t: 0.22 };

  function poserArt() {
    if (!murArt) return;
    murArt.style.width = (murPos.t * 100).toFixed(2) + "%";
    murArt.style.left = (murPos.x * 100).toFixed(2) + "%";
    murArt.style.top = (murPos.y * 100).toFixed(2) + "%";
  }

  function ouvrirMur(handle) {
    var x = (TOUT || []).filter(function (a) { return a.h === handle; })[0];
    var photo = $("[data-palette-mur-photo]");
    if (!mur || !x || !apercu || !apercu.src) return;
    photo.src = apercu.src;
    murArt.src = x.img ? (x.img.indexOf("http") === 0 ? x.img : IDXPREFIXE + x.img) : "";
    $("[data-palette-mur-titre]").textContent = x.titre;
    var lien = $("[data-palette-mur-lien]");
    if (lien) lien.href = ROOT + "products/" + x.h;
    /* Toutes les raisons ici : la carte n'en montre qu'une pour ne pas peser plus que le
       titre, la fenêtre les montre toutes — on a le temps de les lire. */
    var pq = $("[data-palette-mur-pourquoi]");
    if (pq) {
      pq.innerHTML = x.raisons.length
        ? "<h3>" + esc(t("pourquoi_titre", "Pourquoi cette affiche ?")) + "</h3><ul>" +
          x.raisons.map(function (r) { return "<li>" + esc(capitale(r)) + "</li>"; }).join("") + "</ul>"
        : "";
    }
    murPos = { x: 0.5, y: 0.28, t: 0.22 };
    var sl = $("[data-palette-mur-taille]");
    if (sl) sl.value = 22;
    poserArt();
    /* ⛔ L'ECHELLE DEJA CONNUE SURVIT AU CHANGEMENT D'AFFICHE. `ouvrirMur` repose la
       scene a son etat neuf a chaque ouverture : sans cette ligne, choisir une autre
       affiche dans la liste rendait la taille reelle deja calculee, et le client voyait
       son affiche redevenir approximative sans comprendre pourquoi. */
    poseAEchelle();
    mur.hidden = false;
    document.body.style.overflow = "hidden";
  }

  /* ⛔ TOUTES LES AFFICHES, PAS SEULEMENT LES PROPOSEES. Le mur ne s'ouvrait que
     depuis une carte de recommandation : le client qui voulait voir SON affiche dans sa
     piece ne le pouvait pas (Adrien, 03/08/2026). L'index complet des affiches est deja
     charge pour classer les propositions, donc chercher dedans ne coute ni requete ni
     page : on filtre `TOUT`, qui est deja la. */
  var autres = $("[data-palette-autres]");
  var autresOuvre = $("[data-palette-autres-ouvre]");
  var autresCorps = $("#pal-mur-autres-corps");
  var autresQ = $("[data-palette-autres-q]");
  var autresGrille = $("[data-palette-autres-grille]");
  var AUTRES_MAX = 24;

  function sansAccents(x) {
    try { return String(x).normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
    catch (e) { return String(x); }
  }
  function peintAutres() {
    if (!autresGrille) return;
    var q = sansAccents((autresQ && autresQ.value) || "").trim().toLowerCase();
    /* Sans recherche, on montre le debut du catalogue plutot qu'un cadre vide : le
       client voit tout de suite que le champ sert a fouiller, pas a filtrer un vide. */
    var liste = (TOUT || []).filter(function (x) {
      if (!q) return true;
      return sansAccents(x.titre).toLowerCase().indexOf(q) >= 0;
    }).slice(0, AUTRES_MAX);
    autresGrille.innerHTML = liste.map(function (x) {
      var u = x.img ? (x.img.indexOf("http") === 0 ? x.img : IDXPREFIXE + x.img) : "";
      return '<button type="button" class="pal-mur__autre" role="listitem"'
        + ' data-palette-autre="' + esc(x.h) + '" title="' + esc(x.titre) + '">'
        + '<img src="' + esc(u) + '" alt="" loading="lazy">'
        + '<span>' + esc(x.titre) + "</span></button>";
    }).join("");
  }
  if (autresOuvre && autresCorps) {
    autresOuvre.addEventListener("click", function () {
      var ferme = autresCorps.hidden;
      autresCorps.hidden = !ferme;
      autresOuvre.setAttribute("aria-expanded", ferme ? "true" : "false");
      if (ferme) { peintAutres(); if (autresQ) autresQ.focus(); }
    });
  }
  if (autresQ) autresQ.addEventListener("input", peintAutres);
  if (autresGrille) {
    autresGrille.addEventListener("click", function (e) {
      var b = e.target && e.target.closest && e.target.closest("[data-palette-autre]");
      if (!b) return;
      /* `ouvrirMur` repose la scene entierement : la photo de la piece, le titre, le
         lien et le cadrage repartent a l'etat neuf pour la nouvelle affiche. */
      ouvrirMur(b.getAttribute("data-palette-autre"));
      if (autresCorps) { autresCorps.hidden = false; }
      if (autresOuvre) autresOuvre.setAttribute("aria-expanded", "true");
    });
  }

  /* ---- La pose a l'echelle ---------------------------------------------------------
   *
   * ⛔ L'AFFICHE ARRIVE A SA TAILLE REELLE, SANS QUE LE CLIENT LA REGLE (Adrien,
   * 03/08/2026). Une taille reelle ne se deduit pas d'une photo sans repere : GPT sur serveur
   * regarde l'image et rend une echelle en centimetres par pixel, plus le rectangle de
   * mur libre ou poser l'affiche.
   *
   * ⛔ RIEN N'ATTEND. L'affiche est posee tout de suite avec le reglage par defaut et ses
   * poignees ; quand la reponse arrive, elle glisse a la bonne taille. Si elle n'arrive
   * jamais (watcher endormi, mur illisible), le client garde le comportement d'avant et
   * ne voit aucune erreur : un apercu faux coute plus cher que pas d'apercu, un message
   * d'erreur aussi.
   */
  var ECHELLE_BASE = "https://runway.dcomdtf.app/ma-piece-log/echelle";
  /* ⛔ ELLES ABANDONNENT AU BOUT DE 2,5 s. Le Studio tombe, une balise a mis plus de trente
     secondes a rendre la main (mesure du 23/08/2026) : la page s'affiche, mais `load` attend, et
     tout ce qui attend `load` attend avec. Meme aide que dans `global.js`. */
  function afSignalCourt(ms) {
    try { return AbortSignal.timeout(ms || 2500); } catch (e) { return undefined; }
  }
  var ECHELLE_CM = 30;              // largeur du format de reference, 30 x 40 cm
  var echelleLue = null;            // { mur, cm_par_pixel } une fois connue
  var echelleDemandee = "";

  function poseAEchelle() {
    if (!echelleLue || !murArt || !apercu || !apercu.naturalWidth) return;
    /* Le rapport est le meme dans la photo et dans la scene : la scene montre la photo
       entiere, donc une fraction de largeur vaut des deux cotes. */
    var largeurPx = ECHELLE_CM / echelleLue.cm_par_pixel;
    var t = largeurPx / apercu.naturalWidth;
    if (!(t > 0.02 && t < 0.9)) return;      // hors de ces bornes, on garde le defaut
    var m = echelleLue.mur;
    murPos = { x: m.x + m.w / 2, y: m.y + m.h / 2, t: t };
    /* Le curseur suit la pose, sinon il annoncerait une taille que l'affiche n'a pas. */
    var sl = $("[data-palette-mur-taille]");
    if (sl) sl.value = String(Math.round(Math.max(8, Math.min(46, t * 100))));
    poserArt();
  }

  function sondeEchelle(url, restants) {
    if (!url || restants <= 0) return;
    fetch(ECHELLE_BASE + "?u=" + encodeURIComponent(url), { mode: "cors", credentials: "omit", signal: afSignalCourt(2500) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.etat === "pret" && j.echelle) { echelleLue = j.echelle; poseAEchelle(); return; }
        if (j && j.etat === "en_cours") setTimeout(function () { sondeEchelle(url, restants - 1); }, 2000);
        /* `echec` et `absent` s'arretent la : le reglage manuel reste. */
      })
      .catch(function () {});
  }

  function demandeEchelle(url) {
    if (!url || url === echelleDemandee || !window.fetch) return;
    echelleDemandee = url;
    fetch(ECHELLE_BASE, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: url }), mode: "cors", credentials: "omit",
      signal: afSignalCourt(2500)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.etat === "pret" && j.echelle) { echelleLue = j.echelle; poseAEchelle(); return; }
        /* Quinze sondes de deux secondes : au-dela, l'analyse n'arrivera plus a temps
           pour quelqu'un qui regarde son mur. */
        if (j && j.etat === "en_cours") sondeEchelle(url, 15);
      })
      .catch(function () {});
  }

  /* L'adresse arrive quand le depot aboutit, apres que la page a repris la main. */
  window.addEventListener("af:piece-photo", function (e) {
    demandeEchelle((e && e.detail && e.detail.url) || "");
  });
  if (window.afMaPiecePhotoUrl) demandeEchelle(window.afMaPiecePhotoUrl);

  function fermerMur() {
    if (!mur) return;
    mur.hidden = true;
    document.body.style.overflow = "";
  }

  if (mur) {
    mur.addEventListener("click", function (e) {
      if (e.target.closest("[data-palette-mur-fermer]")) fermerMur();
    });
    var sl = $("[data-palette-mur-taille]");
    if (sl) sl.addEventListener("input", function () { murPos.t = Number(sl.value) / 100; poserArt(); });
    /* Déplacement : souris et doigt, même code. `setPointerCapture` évite de perdre
       l'affiche quand le doigt sort de la scène. */
    var prend = false;
    murScene.addEventListener("pointerdown", function (e) {
      if (e.target !== murArt) return;
      prend = true; murArt.setPointerCapture(e.pointerId); e.preventDefault();
    });
    murScene.addEventListener("pointermove", function (e) {
      if (!prend) return;
      var r = murScene.getBoundingClientRect();
      murPos.x = Math.max(0.05, Math.min(0.95, (e.clientX - r.left) / r.width));
      murPos.y = Math.max(0.02, Math.min(0.92, (e.clientY - r.top) / r.height));
      poserArt();
    });
    murScene.addEventListener("pointerup", function () { prend = false; });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !mur.hidden) fermerMur();
    });
  }

  /* Le raisonnement, dit au client avant la grille.
     Trois briques, toutes nourries par la lecture de SA photo : les teintes trouvées, ce
     que la lumière du mur commande, et la pièce si elle est choisie. Pas une phrase par
     combinaison — la couleur et la pièce sont des variables, seule la lumière change
     vraiment le conseil. Chaque phrase dit littéralement ce que le score calcule : si les
     seuils bougent, le texte reste vrai. */
  function listeFr(noms) {
    var l = noms.map(function (n) { return "<b>" + esc(n.toLowerCase()) + "</b>"; });
    if (l.length <= 1) return l[0] || "";
    return l.slice(0, -1).join(", ") + " et " + l[l.length - 1];
  }

  function peindrePourquoi() {
    var el = $("[data-palette-pourquoi]");
    if (!el || !piece) return;
    var cle = piece.clarte === "Sombre" ? "pourquoi_sombre"
            : (piece.clarte === "Clair" ? "pourquoi_clair" : "pourquoi_moyen");
    var txt = t("pourquoi_couleur", "Nous avons lu __C__ sur votre mur.")
                .replace("__C__", listeFr(piece.palette))
            + " " + t(cle, "");
    if (pieceVisee) {
      txt += " " + t("pourquoi_piece", "Et adaptées à un espace de type __P__.")
                     .replace("__P__", "<b>" + esc(pieceVisee.toLowerCase()) + "</b>");
    }
    el.innerHTML = txt;
    el.hidden = false;
  }

  /* Défilement infini. Le bouton « Voir plus » reste la source de vérité — il fonctionne au
     clavier, et l'observateur peut ne jamais se déclencher (onglet en arrière-plan,
     `prefers-reduced-motion`, navigateur ancien). On l'observe, on l'actionne à l'approche.
     Même règle que le défilement infini des pages collection. */
  var oeil = null;
  function observerFin(btn) {
    if (!("IntersectionObserver" in window)) return;
    if (!oeil) {
      oeil = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          var b = e.target;
          if (b.hidden) return;
          montre += MONTRE;
          rendre();
        });
      }, { rootMargin: "600px 0px" });
    }
    oeil.observe(btn);
  }

  /* Un nom de couleur se lit plus vite avec sa couleur devant. Les teintes ne servent qu'à
     l'affichage — le classement, lui, travaille sur les noms de l'index. */
  var TEINTE = {
    "Beige": "#e0d3bb", "Blanc": "#f6f4ef", "Bleu": "#3a6ea5", "Gris": "#9a9a95",
    "Jaune": "#e8bf4a", "Marron": "#7a5637", "Noir": "#26262a", "Orange": "#d98032",
    "Rose": "#dfa0b4", "Rouge": "#b23b34", "Vert": "#5c8a5e", "Violet": "#7d6aa8"
  };

  var IDXPREFIXE = "";
  var ROOT = (root.getAttribute("data-root") || "/").replace(/\/?$/, "/");

  function charger() {
    if (IDX) return Promise.resolve();
    return fetch(root.getAttribute("data-index"))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        IDX = d.affiches; K = d.cles; C = d.constantes; IDXPREFIXE = d.prefixe;
      });
  }

  /* ---------- Événements ---------- */

  var input = $("[data-palette-fichier]");
  var apercu = $("[data-palette-apercu]");
  var etat = $("[data-palette-etat]");

  /* La photo survit au rafraîchissement.
     Elle était perdue à chaque F5 : on retombait sur la zone de dépôt vide, et il fallait
     retrouver le fichier. On la garde RÉDUITE à 640 px dans le stockage de session — assez
     pour la relire, assez petit pour tenir dans le quota — et elle disparaît avec l'onglet.
     C'est cohérent avec ce qu'on promet au client : rien ne quitte son appareil, et rien
     ne s'installe durablement dessus. */
  var CLE_PHOTO = "affichely.palette.photo";

  function retenirPhoto(img) {
    try {
      var c = document.createElement("canvas");
      var ech = Math.min(1, 640 / Math.max(img.naturalWidth, img.naturalHeight));
      c.width = Math.round(img.naturalWidth * ech);
      c.height = Math.round(img.naturalHeight * ech);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      sessionStorage.setItem(CLE_PHOTO, c.toDataURL("image/jpeg", 0.82));
    } catch (e) { /* quota plein ou stockage refusé : on ne retient pas, c'est tout */ }
  }

  function reprendrePhoto() {
    var url;
    try { url = sessionStorage.getItem(CLE_PHOTO); } catch (e) { return; }
    if (!url) return;
    var img = new Image();
    img.onload = function () { appliquerPhoto(img, url, false); };
    img.src = url;
  }

  function appliquerPhoto(img, url, retenir) {
    piece = lirePiece(img);
    if (apercu) {
      apercu.src = url;
      apercu.width = img.naturalWidth;
      apercu.height = img.naturalHeight;
    }
    var drop = $("[data-palette-drop]"), photo = $("[data-palette-photo]");
    if (drop) drop.hidden = true;
    if (photo) photo.hidden = false;
    var pcs = $(".pal__pieces");
    if (pcs) pcs.hidden = false;
    /* Les bénéfices s'adressent à qui hésite à déposer sa photo ; une fois déposée, ils
       n'ont plus rien à lui apprendre. */
    var bn = $("[data-palette-benefs]");
    if (bn) bn.hidden = true;
    /* Le bloc de suggestions n'a de sens que tant qu'on n'a rien à proposer de mieux. Dès
       qu'une photo est lue, la page a SES recommandations : garder un rail générique
       en dessous ferait deux propositions concurrentes, dont l'une ignore le mur. */
    var sug = document.getElementById("shopify-section-suggestions");
    if (sug) sug.hidden = true;
    if (retenir) retenirPhoto(img);
    etat.hidden = true;
    classer();
  }

  function traiter(fichier) {
    if (!fichier) return;
    etat.hidden = false;
    etat.textContent = t("lecture", "Lecture de votre pièce…");
    var url = URL.createObjectURL(fichier);
    var img = new Image();
    img.onload = function () {
      charger().then(function () {
        /* La zone de dépôt s'efface, la photo prend sa place. Elle restait affichée à côté
           d'une vignette minuscule, à réclamer ce qu'on venait de lui donner.
           Les dimensions sont posées côté JS : la photo est un blob local dont Liquid ne
           peut rien savoir, et les écrire en dur aurait déformé les photos verticales. */
        appliquerPhoto(img, url, true);
        /* Une personne de plus dans le funnel Ma piece (Studio, Statistiques). */
        if (window.afMaPieceImport) window.afMaPieceImport(fichier, img);
      }).catch(function () {
        etat.textContent = t("erreur", "Chargement impossible. Réessayez.");
      });
    };
    img.onerror = function () {
      etat.textContent = t("pas_image", "Ce fichier n’est pas une image.");
    };
    img.src = url;
  }

  if (input) {
    input.addEventListener("change", function () { traiter(input.files && input.files[0]); });
  }
  /* Remplacer la photo : le bouton posé sur l'aperçu rouvre le même champ de fichier. */
  var rechanger = $("[data-palette-rechanger]");
  if (rechanger && input) {
    rechanger.addEventListener("click", function () { input.click(); });
  }
  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-pal-open]")) { basculerFeuille(true); return; }
    if (e.target.closest("[data-pal-close]")) { basculerFeuille(false); return; }
    var vm = e.target.closest("[data-palette-voir]");
    if (vm) { e.preventDefault(); ouvrirMur(vm.getAttribute("data-palette-voir")); return; }
    if (e.target.closest("[data-palette-plus]")) { montre += MONTRE; rendre(); return; }
    var p = e.target.closest("[data-palette-piece]");
    if (!p) return;
    var v = p.getAttribute("data-palette-piece");
    pieceVisee = (pieceVisee === v) ? "" : v;
    Array.prototype.forEach.call(root.querySelectorAll("[data-palette-piece]"), function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-palette-piece") === pieceVisee ? "true" : "false");
    });
    /* Changer de pièce rejoue le classement, mais garde les filtres : quelqu'un qui a
       demandé du bleu le veut encore en passant du salon à la chambre. */
    classer();
  });

  /* Au chargement : si une photo de cette session est en mémoire, on la reprend. Le client
     qui rafraîchit retrouve son mur et ses affiches, pas une zone de dépôt vide. */
  charger().then(reprendrePhoto).catch(function () { /* index indisponible : rien à reprendre */ });

  /* Glisser-déposer : sur ordinateur, c'est le geste naturel avec une photo. */
  ["dragover", "drop"].forEach(function (ev) {
    root.addEventListener(ev, function (e) {
      e.preventDefault();
      if (ev === "drop" && e.dataTransfer && e.dataTransfer.files) traiter(e.dataTransfer.files[0]);
    });
  });
})();
